import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ fullPage = false, size = 36, message }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1.5,
        ...(fullPage
          ? {
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(237, 242, 249, 0.85)',
              backdropFilter: 'blur(4px)',
              zIndex: (theme) => theme.zIndex.modal + 1,
            }
          : {
              width: '100%',
              py: 6,
            }),
      }}
    >
      <CircularProgress size={size} thickness={3} sx={{ color: 'primary.main' }} />
      {message && (
        <Typography sx={{ fontSize: '0.8125rem', color: 'text.secondary', fontWeight: 500 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
